module.exports = __webpack_public_path__ + "static/media/emdria.f5245f7e.png";